<div class="messagerie-container">
<app-loader *ngIf="isLoadingConversations || isLoadingConversation || isSendingMessage"></app-loader>

  <!-- Header -->
  <div class="messagerie-header">
    <app-page-title [titleKey]="'messagerie.title'"></app-page-title>
  </div>

  <!-- Children Selector -->
  <div class="children-selector-container">
    <app-children-selector
      [autoSelectFirst]="true"
      (studentSelected)="onStudentSelected($event)">
    </app-children-selector>
  </div>

  <!-- Main Content -->
  <div class="messagerie-content" *ngIf="selectedStudent">
    <!-- Teachers Sidebar -->
    <div class="teachers-sidebar">
      <div class="teachers-header">
        <h3>{{ 'messagerie.conversations' | translate }}</h3>
      </div>
      
      <!-- Loading Teachers -->
      <div class="loading-teachers" *ngIf="isLoadingConversations">
        <div class="loading-spinner"></div>
        <p>{{ 'messagerie.loadingConversations' | translate }}</p>
      </div>
      
      <!-- Teachers List -->
      <div class="teachers-list" *ngIf="!isLoadingConversations && conversations.length > 0">
        <div 
          class="teacher-item" 
          *ngFor="let conversation of conversations" 
          [class.selected]="selectedConversation?.id === conversation.id"
          (click)="selectConversation(conversation)"
        >
          <div class="teacher-avatar">
            <div class="avatar-circle ">
              <img class="w-10 h-10 rounded-full" src="../../../assets/acceuil/Icons/Profil Avatar.jpg" alt="">
            </div>
          </div>
          <div class="teacher-info">
            <div class="teacher-name">{{ conversation.friendName }}</div>
            <div class="teacher-subject">{{ conversation.lastMessageContent || '' }}</div>
          </div>
          <div class="unread-count" *ngIf="conversation.unreadCount > 0">
            {{ conversation.unreadCount }}
          </div>
        </div>
        <button class="btn-start-conversation" (click)="openTargetsModal()" *ngIf="selectedStudent">
          <i class="fas fa-plus"></i>
        </button>
      </div>
      
      <!-- No Teachers -->
      <div class="loading-teachers" *ngIf="!isLoadingConversations && conversations.length === 0">
        <i class="fas fa-comments"></i>
        <p>Aucune conversation disponible</p>
        <button class="btn-start-conversationn" style="margin-top: 10px;" (click)="openTargetsModal()" *ngIf="selectedStudent">
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>

    <!-- Chat Area -->
    <div class="chat-area" *ngIf="selectedConversation || currentConversation; else noConversationSelected">
      <!-- Chat Header -->
      <div class="chat-header">
        <div class="conversation-info">
          <div class="conversation-details">
            <h4>{{ selectedConversation?.friendName || currentConversation?.friendName }}</h4>
          </div>
        </div>
      </div>


      <!-- Messages Container -->
      <div class="messages-container" #messagesContainer *ngIf="!isLoadingConversation; else loadingConversation">
        <!-- Loading Messages -->
        <div class="loading-messages" *ngIf="isLoadingMessages">
          <div class="loading-spinner"></div>
          <p>Chargement des messages...</p>
        </div>

        <!-- Messages List -->
        <div class="messages-list" *ngIf="!isLoadingMessages && groupedMessages.length > 0">
          <div *ngFor="let group of groupedMessages">
            <div class="message-date-separator">
              <span>{{ group.date }}</span>
            </div>
            <div 
              class="message" 
              *ngFor="let message of group.messages"
              [class.sent]="message.user.id === selectedStudent.idUserStudent"
              [class.received]="message.user.id !== selectedStudent.idUserStudent"
            >
              <div class="message-content">
                <p>{{ message.messageContent }}</p>
                <div class="message-files" *ngIf="message.listPieceJoint?.pieceJoint && message.listPieceJoint.pieceJoint.length > 0">
                  <div class="file-item" *ngFor="let file of message.listPieceJoint.pieceJoint" (click)="openFileModal(file)">
                    <i class="fas fa-file"></i>
                    <a [href]="file.url" (click)="logFileLink(file.url)" target="_blank">{{ file.name }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="no-messages" *ngIf="!isLoadingMessages && groupedMessages.length === 0">
          <i class="fas fa-comments"></i>
          <p>Aucun message dans cette conversation</p>
        </div>
      </div>
      
      <ng-template #loadingConversation>
        <div class="loading-conversation">
          <div class="loading-spinner"></div>
          <p>{{ 'messagerie.loadingConversation' | translate }}</p>
        </div>
      </ng-template>
      
      <!-- Selected Files Display -->
      <div class="selected-files" *ngIf="selectedFiles.length > 0">
        <div class="files-header">
          <span>Fichiers sélectionnés:</span>
                    <div class="files-list">
            <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
              <i class="fas fa-file"></i>
              <span class="file-name">{{ file.name }}</span>
              <button class="btn-remove-file" (click)="removeFile(i)" title="Supprimer ce fichier">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          <button class="btn-clear-files" (click)="clearFiles()" title="Supprimer tous les fichiers">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Message Input -->
      <div class="message-input-container">
        <button class="btn-attach" (click)="attachFile()" title="Joindre un fichier">
          <i class="fas fa-paperclip"></i>
        </button>
        
        <textarea 
          [(ngModel)]="newMessage" 
          (keypress)="onKeyPress($event)"
          placeholder="Tapez votre message..."
          class="message-input"
          rows="1"
          [disabled]="isSendingMessage">
        </textarea>
        
        <button 
          class="btn-send" 
          (click)="sendMessage()"
          [disabled]="(!newMessage.trim() && selectedFiles.length === 0) || isSendingMessage"
          title="Envoyer le message">
          <i class="fas fa-paper-plane" *ngIf="!isSendingMessage"></i>
          <div class="loading-spinner small" *ngIf="isSendingMessage"></div>
        </button>
      </div>
    </div>

    <!-- No Conversation Selected -->
    <ng-template #noConversationSelected>
      <div class="no-conversation-selected">
        <div class="empty-state">
          <i class="fas fa-comments"></i>
          <h3>{{ 'navigation.selectConversation' | translate }}</h3>
          <p>{{ 'navigation.chooseOrCreateConversation' | translate }}</p>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- No Student Selected -->
    <div class="no-student-selected" *ngIf="!selectedStudent">
      <div class="empty-state">
        <div class="empty-icon">👨‍🎓</div>
        <h3>Sélectionnez un étudiant</h3>
        <p>Choisissez un étudiant pour voir ses conversations</p>
      </div>
    </div>
    <!-- File View Modal -->
  <div class="modal-overlay" *ngIf="showFileModal" (click)="closeFileModal()">
    <div class="modal-content file-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ currentFile?.name }}</h3>
        <button class="btn-close" (click)="closeFileModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body file-modal-body">
        <img *ngIf="isImage(currentFile?.type)" [src]="currentFile?.piece" alt="File Preview" class="file-preview-image">
        <iframe *ngIf="isPdf(currentFile?.type)" [src]="currentFile?.piece" class="file-preview-iframe"></iframe>
        <div *ngIf="!isImage(currentFile?.type) && !isPdf(currentFile?.type)">
          <p>No preview available for this file type.</p>
          <a [href]="currentFile?.piece" target="_blank" class="btn btn-primary">Download File</a>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Message Targets Modal -->
<div class="modal-overlay" *ngIf="showTargetsModal" (click)="closeTargetsModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Choisir un destinataire</h3>
      <button class="btn-close" (click)="closeTargetsModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <div class="modal-body">
      <!-- Loading Targets -->
      <div class="loading-container" *ngIf="isLoadingTargets">
        <div class="spinner"></div>
        <p>Chargement des destinataires...</p>
      </div>
      
      <!-- Targets List -->
      <div class="targets-list" *ngIf="!isLoadingTargets && messageTargets.length > 0">
        <div 
          class="target-item" 
          *ngFor="let target of messageTargets"
          (click)="selectTarget(target)"
        >
          <div class="target-avatar">
            <img [src]="target.avatar || '/assets/acceuil/Icons/Profil%20Avatar.jpg'" [alt]="target.name" (error)="setDefaultTargetAvatar($event)">
          </div>
          <div class="target-info">
            <div class="target-name">{{ target.name }}</div>
            <div class="target-role">{{ target.role || 'Enseignant' }}</div>
          </div>
        </div>
      </div>
      
      <!-- No Targets -->
      <div class="no-targets" *ngIf="!isLoadingTargets && messageTargets.length === 0">
        <i class="fas fa-user-slash"></i>
        <p>Aucun destinataire disponible</p>
      </div>
    </div>
  </div>
</div>